import httpClient from './httpClient'

const END_POINT = '/user'

const getUser = (userId) => httpClient.get(END_POINT + '/' + userId)

export {
  getUser
}
